module.exports = __webpack_public_path__ + "img/SueloAbundante.3731977a.jpg";